import { render, staticRenderFns } from "./wxaauth.vue?vue&type=template&id=29494d67&"
import script from "./wxaauth.vue?vue&type=script&lang=ts&"
export * from "./wxaauth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports